import { Check } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { BaseFilterDropdown } from './BaseFilterDropdown';

type CheckboxDropdownProps = {
  title: string;
  items: { name: string; value: string }[];
  isOpen: boolean;
  onToggle: () => void;
  selectedItems: string[];
  onSelectionChange: (selectedItems: string[]) => void;
  loading: boolean;
};

export function FilterDropdownCheckbox({
  title,
  items,
  isOpen,
  onToggle,
  selectedItems,
  onSelectionChange,
  loading,
}: CheckboxDropdownProps) {
  const t = useTranslations('FilterDropdown');

  const toggleItem = (value: string) => {
    const updatedItems = selectedItems.includes(value)
      ? selectedItems.filter(item => item !== value)
      : [...selectedItems, value];
    onSelectionChange(updatedItems);
  };

  return (
    <BaseFilterDropdown
      title={title}
      isOpen={isOpen}
      onToggle={onToggle}
      selectedCount={selectedItems.length}
    >
      {loading
        ? (
            <div className="px-[12px] py-[8px] text-center text-[#606384]">
              {t('loading')}
            </div>
          )
        : items.length === 0
          ? (
              <div className="px-[12px] py-[8px] text-center text-[#606384]">
                {t('no_items')}
              </div>
            )
          : (
              items.map(item => (
                <div
                  key={item.value}
                  className="flex cursor-pointer items-center px-[12px] py-[8px]"
                  onClick={() => toggleItem(item.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      toggleItem(item.value);
                    }
                  }}
                  role="option"
                  tabIndex={0}
                  aria-selected={selectedItems.includes(item.value)}
                >
                  <div
                    className={`flex size-[20px] shrink-0 items-center justify-center rounded-sm ${
                      selectedItems.includes(item.value)
                        ? 'bg-black text-white'
                        : 'border border-[#D4D6EC] bg-white text-transparent'
                    }`}
                  >
                    {selectedItems.includes(item.value) && <Check className="size-4" />}
                  </div>
                  <span className="ml-[12px] break-words font-normal">{item.name}</span>
                </div>
              ))
            )}
    </BaseFilterDropdown>
  );
}
